var QueryParamsService = /** @class */ (function () {
    function QueryParamsService(location) {
        var _this = this;
        this.getQueryParam = function (paramTitle) {
            var queryParams = _this.location.query;
            _this.setAndCurrentUpdateQueryParams(paramTitle, queryParams[paramTitle]);
            return queryParams[paramTitle];
        };
        this.setAndCurrentUpdateQueryParams = function (paramTitle, paramValue) {
            var index = -1;
            _this.currentUrlSearchParams.forEach(function (param, i) {
                /* istanbul ignore next: todo: test */
                if (param.paramTitle === paramTitle) {
                    index = i;
                }
            });
            if (index === -1) {
                _this.currentUrlSearchParams.push({ paramTitle: paramTitle, paramValue: paramValue });
            }
            else {
                _this.currentUrlSearchParams[index] = { paramTitle: paramTitle, paramValue: paramValue };
            }
        };
        this.location = location;
        this.currentUrlSearchParams = [];
    }
    return QueryParamsService;
}());
export { QueryParamsService };
//# sourceMappingURL=QueryParamsService.js.map